import { render, staticRenderFns } from "./LandmarkEditor.vue?vue&type=template&id=5b22ad40&scoped=true"
import script from "./LandmarkEditor.vue?vue&type=script&lang=js"
export * from "./LandmarkEditor.vue?vue&type=script&lang=js"
import style0 from "./LandmarkEditor.vue?vue&type=style&index=0&id=5b22ad40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22ad40",
  null
  
)

export default component.exports